import cx from 'classnames';
import { Card } from 'components/admin/ui';
import { ElementType, ReactNode } from 'react';
import css from './AuthCard.module.scss';

interface IAuthCardProps {
  children: ReactNode;
}

export const AuthCard = ({ children }: IAuthCardProps) => {
  return <Card className={css.card}>{children}</Card>;
};

interface IAuthCardTitleProps {
  icon?: ElementType;
  title: string;
}

const AuthCardTitle = ({ icon: Icon, title }: IAuthCardTitleProps) => (
  <Card.Title as="h1" className={css.title}>
    {!!Icon && (
      <div aria-hidden>
        <Icon height={24} width={24} />
      </div>
    )}
    <p>{title}</p>
  </Card.Title>
);

interface IAuthCardBodyProps {
  children: ReactNode;
}

const AuthCardBody = ({ children }: IAuthCardBodyProps) => (
  <div className={css.body}>{children}</div>
);

interface IAuthCardTextProps {
  children: string | ReactNode;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'info' | 'important';
}

export const AuthCardText = ({
  children,
  className,
  size = 'md',
  variant = 'default',
}: IAuthCardTextProps) => (
  <p className={cx(css.text, css[variant], css[size], className)}>{children}</p>
);

AuthCard.Title = AuthCardTitle;
AuthCard.Body = AuthCardBody;
AuthCard.Text = AuthCardText;
